import { tv } from 'tailwind-variants'

export const dialogStyles = tv({
	slots: {
		overlayWebOpen:
			'z-50 bg-transparent flex justify-center items-center p-2 web:animate-in web:fade-in-0',
		overlayWebClosed:
			'z-50 bg-transparent flex justify-center items-center p-2 web:animate-out web:fade-out-0',
		overlayNative: 'z-50 flex bg-transparent justify-center items-center p-2',
		contentOpen:
			'z-50 w-screen web:cursor-default bg-palette_5 web:duration-200 web:animate-in web:fade-in-0 web:zoom-in-95 flex items-center justify-center',
		contentClosed:
			'z-50 w-screen web:cursor-default bg-palette_5 web:duration-200 web:animate-out web:fade-out-0 web:zoom-out-95 flex items-center justify-center',
		closeButton:
			'p-9 android:right-2 android:top-[3.40rem] ios:top-6 z-30 web:group web:ring-offset-background web:transition-opacity',
		header: 'flex flex-col gap-6 lg:max-w-md max-w-64 items-center justify-center',
		footer: 'flex gap-8 flex-col',
		title:
			'tracking-tight web:select-text text-palette_3 font-primary text-3xl lg:text-6xl font-primary-bold text-center max-w-md',
		description:
			'tracking-normal text-base web:select-text text-palette_3 font-primary text-pretty text-center',
		logoContainer: 'z-30 android:top-[3.40rem] ios:top-6 left-4 p-6',
	},
	variants: {
		variant: {
			info: {
				contentOpen: 'bg-palette_5',
				contentClosed: 'bg-palette_5',
				title: 'text-palette_6',
				description: 'text-palette_6',
			},
			nav: {
				contentOpen: 'bg-palette_3',
				contentClosed: 'bg-palette_3',
				title: 'text-palette_6',
				description: 'text-palette_6',
			},
			billing: {
				contentOpen: 'bg-palette_3',
				contentClosed: 'bg-palette_3',
				title: 'text-left text-palette_6',
				description: 'text-palette_6',
			},
			confirmation: {
				contentOpen: 'bg-palette_2',
				contentClosed: 'bg-palette_2',
				title: 'text-palette_6',
				description: 'text-palette_6',
			},
		},
	},
	defaultVariants: {
		variant: 'info',
	},
})
